
export default function ComparisonSection() {
  const comparisons = [
    {
      label: 'vs. Maurten',
      category: 'CARBS',
      thresh:
        'No bottle size restriction. Dose 30g to 120g in any size bottle. 1:0.8 maltodextrin:fructose ratio — same science, zero restrictions.',
      competitor:
        'Requires exactly 500ml. Hydrogel tech that independent research shows no clear GI benefit over standard carb blends.'
    },
    {
      label: 'vs. LMNT',
      category: 'ELECTROLYTES',
      thresh:
        'Complete matrix. Sodium citrate + potassium + magnesium glycinate + calcium. High-dose Ironman-grade sodium. Superior mineral forms for real absorption.',
      competitor:
        'Sodium-heavy. No calcium. Low magnesium. Good for gym sessions — under-dosed for 6-hour efforts.'
    },
    {
      label: 'vs. everything else',
      category: 'CAFFEINE',
      thresh:
        '30mg precision scoops. Paired with L-Theanine 2:1 for smooth focus. No jitters. Completely separate from carbs so you control both independently.',
      // Use double quotes to avoid terminating the string at the apostrophe
      competitor:
        "Caffeine bundled with carbs. You can't adjust one without adjusting the other."
    }
  ];

  return (
    <section className="bg-white py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl lg:text-6xl font-bold text-black mb-6 leading-tight">
            Why Every Ingredient Was Chosen
          </h2>
          <p className="text-xl text-gray-600 max-w-[700px] mx-auto">
            We didn't just create another sports drink. We rebuilt the system from scratch.
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="space-y-12 lg:space-y-16">
          {comparisons.map((comparison, index) => (
            <div
              key={index}
              className="bg-[#FAFAFA] border-2 border-black rounded-2xl p-10 lg:p-14 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-1 transition-all duration-300"
            >
              {/* Header */}
              <div className="flex items-center gap-4 mb-8">
                <span className="inline-block bg-[#00FF88] text-black text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full">
                  {comparison.category}
                </span>
                <span className="text-lg font-bold text-gray-500">{comparison.label}</span>
              </div>

              {/* Comparison Grid */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
                {/* THRESH */}
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-full bg-[#00FF88] flex items-center justify-center">
                      <i className="ri-check-line text-xl text-black font-bold"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-black">THRESH</h3>
                  </div>
                  <p className="text-base lg:text-lg text-gray-700 leading-relaxed">{comparison.thresh}</p>
                </div>

                {/* Competitor */}
                <div className="opacity-60">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center">
                      <i className="ri-close-line text-xl text-gray-600 font-bold"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-600">
                      {comparison.label.replace('vs. ', '')}
                    </h3>
                  </div>
                  <p className="text-base lg:text-lg text-gray-600 leading-relaxed">{comparison.competitor}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-20">
          <p className="text-lg text-gray-600 mb-6">
            Every ingredient. Every dose. Every decision backed by research.
          </p>
          <a
            href="#early-access"
            className="inline-block whitespace-nowrap px-10 py-4 bg-black text-white font-bold rounded-lg hover:scale-105 hover:shadow-[0_0_30px_rgba(0,0,0,0.3)] transition-all duration-300 cursor-pointer"
          >
            JOIN THE LIST
          </a>
        </div>
      </div>
    </section>
  );
}
